/**
 * Описание аннотации приходит HTML-ом из редактора. Внутри iframe эмбеда
 * обычная ссылка открывается в самом iframe, поверх плеера. Ставим всем
 * ссылкам без явного target открытие в новой вкладке.
 */
export default function openLinksInNewTab(html) {
  if (!html) return html;

  return html.replace(
    /<a\s(?![^>]*\btarget\s*=)/gi,
    '<a target="_blank" rel="noopener noreferrer" '
  );
}
